import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import { pathOr } from 'ramda';
import { Grid } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';
import {
  AccountDetails,
  BrandAsset,
  getImageFromPath,
} from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantBrandAssets/MerchantBrandAssets.helpers';

import styles from 'scenes/Home/scenes/MerchantStatusDetails/scenes/sections/MerchantBrandAssets/MerchantBrandAssets.styles';

type Styles = ClassProp<ReturnType<typeof styles>>;

type Props = {
  classes: Styles;
  accountDetails: AccountDetails;
  brandAssets: BrandAsset;
  category?: string;
  subCategory?: string;
};

const Tier3Layout: FunctionComponent<Props> = ({
  classes,
  brandAssets,
  accountDetails,
  category,
  subCategory,
}) => {
  const { name, description } = brandAssets;

  const {
    address1,
    address2,
    city,
    state,
    postal,
    numberOfStores,
    pointOfSaleSystem,
    title,
    firstName,
    lastName,
    email,
    phone,
  } = accountDetails;

  const bundle = pathOr('', ['assets'], brandAssets);

  return (
    <Grid className={classes.grid}>
      <Grid.Row className={classes.gridRow}>
        <Grid.Column width={6}>
          <div className={classes.clientWrapper}>
            <img
              className={classes.clientLogo}
              src={getImageFromPath(['icon', 'path'], bundle) as string}
            />
            <div className={classes.clientInfo}>
              <h3 className={classes.businessName}>{name}</h3>
              <span>{address1}</span>
              <span>{address2}</span>
              <span className={classes.spacer}>
                {`${city}, ${state} ${postal} `}
              </span>
              <label className={classes.label}>
                Locations: {numberOfStores}{' '}
              </label>
            </div>
          </div>
        </Grid.Column>
        <Grid.Column width={5} className={classes.gridColumn}>
          <div className={classes.fieldGroup}>
            <label className={classes.label}>Business Category:</label>
            {category}
          </div>
          <div className={classes.fieldGroup}>
            <label className={classes.label}>Business Sub-Category:</label>
            {subCategory}
          </div>
          <div className={classes.fieldGroup}>
            <label className={classes.label}>Point of Sale System:</label>
            {pointOfSaleSystem}
          </div>
        </Grid.Column>
        <Grid.Column width={5} className={classes.gridColumn}>
          <div className={classes.fieldGroup}>{title}</div>
          <div className={classes.fieldGroup}>{`${firstName} ${lastName}`}</div>
          <div className={classes.fieldGroup}>
            <a href="mailto:#">{email}</a>
          </div>
          <div className={classes.fieldGroup}>
            <span>{phone}</span>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width="12">
          <div>{description}</div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <img
          className={classes.banner}
          src={getImageFromPath(['banner', 'path'], bundle) as string}
        />
      </Grid.Row>
    </Grid>
  );
};

export default withStyles(styles)(Tier3Layout);
